import { useAppSelector } from '@/hooks/redux-hooks';

export const useSelectedSymbols = () => {
  return useAppSelector(state => state.symbolSelector.symbols);
};
